<template>
    <CardPage :section="1" :page="3" :nextDisabled="nextDisabled" :audio="true">
        <p class="caption font-weight-bold mb-1">
            Step 1 of 2
        </p>
        <p>
            Before you meet your House of LifeSkills family, let’s set up the app. This will just take a few moments.
        </p>
        <p class="caption font-weight-bold mb-1 input-label">
            What’s the name you go by?
        </p>
        <v-text-field outline single-line type="text" v-model.trim="name" @input="name = upperFirst(name)"></v-text-field>
        <p class="caption font-weight-bold mb-1 input-label">
            What are your pronouns?
        </p>
        <v-radio-group v-model="pronounSelection" column>
            <v-radio v-for="(choice, index) in pronounChoices" :key="index" :label="choice" :value="choice"></v-radio>
            <v-radio label="Don’t use pronouns" value="none"></v-radio>
            <v-radio :label="specifyPronounLabel" value="other"></v-radio>
        </v-radio-group>
        <v-text-field v-if="pronounSelection === 'other'" outline single-line type="text" v-model.trim="pronounEntry"></v-text-field>
    </CardPage>
</template>

<script>
import { sync } from 'vuex-pathify';
import { upperFirst } from 'lodash';

export default {
    data: function() {
        return {
            pronounChoices: ['she', 'he', 'they', 'ze'],
            pronounEntry: null,
            pronounSelection: null
        };
    },
    computed: {
        name: sync('preferences@name'),
        pronoun: sync('preferences@pronoun'),
        noPronoun: sync('preferences@noPronoun'),
        specifyPronounLabel() {
            return 'Something else' + (this.pronounSelection === 'other' ? ' (specify)' : '');
        }
    },
    watch: {
        pronounSelection(newPronoun) {
            if (newPronoun === 'other') {
                this.pronoun = this.pronounEntry || '';
                this.noPronoun = false;
            } else if (newPronoun === 'none') {
                this.pronoun = '';
                this.noPronoun = true;
            } else {
                this.pronoun = newPronoun;
                this.noPronoun = false;
            }
        },
        pronounEntry(newPronoun) {
            if (this.pronounSelection === 'other') {
                this.pronoun = newPronoun;
            }
        }
    },
    methods: {
        upperFirst: upperFirst,
        nextDisabled() {
            return !this.name || (!this.noPronoun && !this.pronoun.split(/\/|-/)[0].trim()) || (this.pronounSelection === 'other' && !this.pronounEntry);
        }
    },
    mounted() {
        if (this.noPronoun) {
            this.pronounSelection = 'none';
        } else {
            if (this.pronoun === null || this.pronounChoices.includes(this.pronoun) || this.pronoun === '') {
                this.pronounSelection = this.pronoun;
            } else {
                this.pronounEntry = this.pronoun;
                this.pronounSelection = 'other';
            }
        }
    }
};
</script>
